export default __webpack_public_path__ + "static/media/vegshelf-blog-independent-retail-for-emerging-cpg.0a608e10.png";